import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { PublicProvider } from './publicContext';
import { storageHelper } from '../../lib';
import {recapcha} from "../../api/recapcha";
import {phoneAuth, verifyPhone} from "../../api/signup";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp(props) {
  const { history } = props;
  const classes = useStyles();
  const [otp, setOTP] = useState(null);
  const [isOTP, setIsOTP] = useState(false);
  const [id, setID] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  useEffect(() => {
    if (!isOTP) {
      recapcha(sendCode, 'sign-in-button')
    }
  });

 const sendCode = async (event) => {
  event && event.preventDefault();
  if (phoneNumber.length === 10) {
    storageHelper.set("phone", phoneNumber)
    const response = await phoneAuth(phoneNumber);
        if (response) {
          setIsOTP(true);
          setID(response);
        }
    }
    if (!phoneNumber.length === 10) {
      console.error("invalid phone number");
    }
  };

  const verifyCode = async (event) => {
    event.preventDefault();
        const response = await verifyPhone(id, otp);
        if (response) {
          storageHelper.set("tokenId", response.uid);
          storageHelper.set("route", "/edit-profile");
          history.push("/edit-profile");
        }
	  };
  

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <br />
      <PublicProvider value={{
        uid: id,
        phoneNumber,
      }} >
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="fname"
                name="phoneNumber"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="Phone Number"
                autoFocus
                onChange={(value) => setPhoneNumber(value.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              {isOTP && <TextField
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Verify OTP"
                name="verifyOTP"
                autoComplete="lname"
                onChange={(value) => setOTP(value.target.value)}
              />}
            </Grid>
          </Grid>
          <Button
            id="sign-in-button"
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={(event) => !isOTP ? sendCode(event) : verifyCode(event)}
          >
            {(!isOTP && "Sign Up") || "Verify OTP"}
          </Button>
        
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="#" variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
        </PublicProvider>
    </Container>
  );
}